{
  "actions": "Műveletek"
}
